import {
  LOGIN_SUCCESS,
  LOGOUT,
  LOAD_USER_FROM_STORAGE,
  USER_LOADING
} from '../actions/types'


const initialState = {
  access_token: null,
  isAuthenticated: false,
  isLoading: false,
  tenant: null,
  permissions: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        isLoading: true
      }

    case LOGIN_SUCCESS:
      return {
        access_token: action.payload.access_token,
        isAuthenticated: true,
        isLoading: false,
        tenant: {
          ...action.payload.tenant
        },
        permissions: action.payload.tenant_permissions !== undefined ? action.payload.tenant_permissions : []
      }

    case LOAD_USER_FROM_STORAGE:
      return {
        access_token: action.payload.user.access_token,
        isAuthenticated: true,
        isLoading: false,
        tenant: {
          ...action.payload.user.tenant
        },
        permissions: action.payload.user.permissions
      }

    case LOGOUT:
      localStorage.removeItem('user')
      return {
        access_token: null,
        isAuthenticated: false,
        isLoading: false,
        tenant: null,
        permissions: []
      }

    default:
      return state
  }
}
